import ApplicationsIcon from '@mui/icons-material/GroupAdd';
import TurnIcon from '@mui/icons-material/AssignmentTurnedIn';
import BlockIcon from '@mui/icons-material/Block';

import {
  PRIVATE,
  FROZEN,
} from '~/components/ShiftDetailCardApplicationStatus/constants';
import {
  ShiftApplicationResource,
  ShiftResource,
  TurnResource,
} from '~/generated';
import { useIntl } from 'react-intl';
import styles from './styles.module.css';
import Event from '../Event';
import messages from './messages';

const getEventThemeByShiftState = (
  assignmentState?: string,
  applicationState?: string,
  isCanceled?: boolean
) => {
  if (isCanceled) {
    return 'red';
  }
  switch (applicationState) {
    case 'private':
      return 'orange-striped';
    default:
      break;
  }
  switch (assignmentState) {
    case 'changed':
      return 'orange';
    case 'committed':
      return 'blue';
    case 'finalized':
      return 'green';
    default:
      return 'orange-striped';
  }
};

const iconStyle = {
  width: '16px',
  height: '16px',
};

type WeekplanShiftEventProps = {
  onClick: () => void;
  shift: ShiftResource;
  isDimmed: boolean;
  isHighlighted: boolean;
};

export const WeekplanShiftEvent = (props: WeekplanShiftEventProps) => {
  const intl = useIntl();
  const numberOfUnassignedApplications = props.shift.applications?.filter(
    (appl) => !(appl as ShiftApplicationResource).plannedTurn
  ).length;
  const numberOfActiveTurns = props.shift.turns?.filter(
    (turn) => (turn as TurnResource).isEnabled
  ).length;
  return (
    <Event
      onClick={props.onClick}
      startDate={props.shift.startDate}
      endDate={props.shift.endDate}
      theme={getEventThemeByShiftState(
        props.shift.assignmentState?.toLowerCase(),
        props.shift.applicationState?.toLowerCase(),
        props.shift.isCanceled
      )}
      isDimmed={props.isDimmed}
      isHighlighted={props.isHighlighted}
    >
      <div className={styles.event}>
        <div className={styles.footer}>
          {props.shift.applicationState !== PRIVATE && (
            <div className={styles['metric-wrapper']}>
              <div
                className={styles.metric}
                data-test="weekplan-event-applications"
              >
                <ApplicationsIcon color="action" style={iconStyle} />
                <span>{numberOfUnassignedApplications}</span>
              </div>
              <div
                className={styles.metric}
                data-test="weekplan-event-active-turns"
              >
                <TurnIcon color="action" style={iconStyle} />
                <span>{numberOfActiveTurns}</span>
              </div>
            </div>
          )}
          {props.shift.applicationState === FROZEN && (
            <BlockIcon
              color="action"
              style={iconStyle}
              aria-label={intl.formatMessage(messages.applicationsBlocked)}
            />
          )}
        </div>
      </div>
    </Event>
  );
};

WeekplanShiftEvent.displayName = 'WeekplanShiftEvent';

export default WeekplanShiftEvent;
